import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { makeStyles } from '@material-ui/core/styles';
import ButtonCustom from '../../common/components/ui/button/button';
import { useSelector } from "react-redux";
import * as actions from '../../store/actions/index';
import { getSupplierProfile } from '../../store/actions/supplierProfile';
import { connect } from 'react-redux';
import { sub } from 'date-fns';
import MaterialTable from 'material-table';
import { formatDate } from './../../common/utils/utility';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';

const SupplierProfile = (props) => {
    const subscriptionType = [
        "Type 1",
        "Type 2",
        "Type 3"
    ];
    const initialInfo = {
        id: '',
        netsuiteId: '',
        subscriptionType: '',
        subscriptionPrice: '',
        subscriptionStartDate: '',
        subscriptionEndDate: '',
        users: [],
    };
    const userInfo = useSelector((state) => state.auth.userInfo);
    const [supplierProfile, setSupplierProfile] = useState(initialInfo);

    const getSupplierProfileInfo = (supplierId) => {
        getSupplierProfile(supplierId).then(response => {
            let responseData = response.data;
            responseData.subscriptionStartDate = cleanDate(responseData.subscriptionStartDate);
            responseData.subscriptionEndDate = cleanDate(responseData.subscriptionEndDate);

            setSupplierProfile(responseData);
        }).catch((err) => {
            const errMsg = 'Something went wrong';
        });
    };

    const cleanDate = (date) => {
        const defaultDateFromDB = '0001-01-01T00:00:00';
        let cleanDate = date;
        if (!date || date == defaultDateFromDB) {
            cleanDate = '';
        }
        return cleanDate;
    }

    useEffect(() => {
        if (userInfo) {
            getSupplierProfileInfo(userInfo.supplierId);
        }
    }, [userInfo]);

    const UserTable = () => {
        return (
            <React.Fragment>
                <MaterialTable
                    columns={[
                        { title: 'Name', field: 'fullName' },
                        { title: 'Email', field: 'email' },
                        { title: 'Active', field: 'isActive' }
                    ]}
                    data={supplierProfile.users}
                    options={{
                        filtering: false,
                        actionsColumnIndex: -1,
                        search: false,
                        paging: true,
                        toolbar: false,
                        pageSize: 10,
                        headerStyle: {
                            backgroundColor: 'gray',
                            color: '#FFF'
                        },
                    }}
                    localization={{ body: { emptyDataSourceMessage: "" } }}
                />

            </React.Fragment>
        );
    }

    return (
        <Container>
            <Row className="page-header-container">
                <Col>
                    <h2 className="page-header">Supplier Profile</h2>
                </Col>
            </Row>
            <Row className="page-content-container">
                <Col className="page-content-container-inner">
                    <ValidatorForm noValidate autoComplete="off" onSubmit={() => { } }>
                        <Col sm={12} lg={6}>
                            <TextValidator
                                id="subscriptionType"
                                select
                                disabled={true}
                                hidden={supplierProfile.subscriptionType == '' || supplierProfile.subscriptionType == null}
                                autoComplete="off"
                                label="Subscription Type"
                                variant="outlined"
                                value={supplierProfile.subscriptionType || ''}
                            >
                                {subscriptionType.map((option, index) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </TextValidator>
                        </Col>
                        <Col sm={12} lg={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    id="SubscriptionStartDate"
                                    required={false}
                                    disabled={true}
                                    format="M/dd/yyyy"
                                    hidden={supplierProfile.subscriptionStartDate == ''}
                                    label="Subscription Start Date"
                                    value={supplierProfile.subscriptionStartDate || ''}
                                />
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col sm={12} lg={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    id="SubscriptionEndDate"
                                    required={false}
                                    disabled={true}
                                    format="M/dd/yyyy"
                                    hidden={supplierProfile.subscriptionEndDate == ''}
                                    label="Subscription End Date"
                                    value={supplierProfile.subscriptionEndDate || ''}
                                />
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col sm={12} lg={12}>
                            <Row>
                                <Col>
                                    <h3 className="section-header">Users</h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {UserTable()}
                                </Col>
                            </Row>
                        </Col>
                    </ValidatorForm>           
                </Col>
            </Row>
        </Container>
  );
}

export default connect(
)(SupplierProfile);
